const mediaItems = [
  {
    title: '《暗夜追踪》第三季幕后特辑',
    desc: '独家探班片场花絮，揭秘悬疑大剧的拍摄幕后，导演与主演深度访谈',
    image: 'https://readdy.ai/api/search-image?query=Film%20production%20crew%20working%20on%20set%20with%20professional%20camera%20equipment%2C%20behind%20the%20scenes%20of%20TV%20drama%20shooting%2C%20warm%20studio%20lighting%2C%20cinematic%20production%20atmosphere&width=600&height=380&seq=media-01-crew&orientation=landscape',
    duration: '15:32',
    views: '128万',
  },
  {
    title: '暑期档必看十大佳片盘点',
    desc: '影评人带你快速了解今年暑期档最值得期待的十部院线大片',
    image: 'https://readdy.ai/api/search-image?query=Movie%20theater%20interior%20with%20film%20posters%20displayed%20on%20wall%2C%20cinema%20lobby%20atmosphere%2C%20warm%20ambient%20lighting%2C%20popcorn%20and%20movie%20memorabilia%2C%20entertainment%20lifestyle%20scene&width=600&height=380&seq=media-02-summer&orientation=landscape',
    duration: '08:45',
    views: '96万',
  },
  {
    title: '《星际征途》导演深度解读',
    desc: '科幻巨制导演亲自解读影片中的哲学思考与视觉设计理念',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20film%20set%20with%20green%20screen%20and%20advanced%20technology%20props%2C%20director%20discussing%20scene%20with%20actors%2C%20professional%20film%20production%20environment%2C%20cinematic%20lighting&width=600&height=380&seq=media-03-scifi&orientation=landscape',
    duration: '22:10',
    views: '156万',
  },
];

export default function Media() {
  return (
    <section id="media" className="py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-10 md:mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
            精彩视频
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950">
            影视特辑
          </h2>
          <p className="mt-2 text-foreground-500 text-sm md:text-base">
            幕后花絮、深度解读与独家盘点精彩内容
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {mediaItems.map((item) => (
            <article
              key={item.title}
              className="group bg-white rounded-2xl overflow-hidden hover:bg-primary-50/20 transition-colors duration-300"
            >
              <div className="relative aspect-video overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/20 flex items-center justify-center">
                  <div className="w-14 h-14 rounded-full bg-white/90 flex items-center justify-center group-hover:bg-primary-500 group-hover:text-white transition-all duration-300">
                    <i className="ri-play-fill text-2xl ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-3 right-3 px-2.5 py-1 rounded-lg bg-black/60 text-white text-xs backdrop-blur-sm">
                  {item.duration}
                </span>
              </div>
              <div className="p-5 md:p-6">
                <h3 className="text-base md:text-lg font-heading font-bold text-foreground-900 mb-2 line-clamp-1">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed mb-3 line-clamp-2">
                  {item.desc}
                </p>
                <div className="flex items-center gap-2 text-xs text-foreground-400">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-eye-line"></i>
                  </div>
                  {item.views} 次观看
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}